import { useState } from "react";
import { ArrowRight, Instagram, Linkedin, MessageCircle } from "lucide-react";
import ConsultationDialog from "./ConsultationDialog";

export default function Footer() {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* CTA */}
      <section id="contact" className="bg-[#f3ece1] py-20">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-10 items-center">
          <h2 className="lg:col-span-4 font-serif text-3xl md:text-4xl leading-[1.2] text-[#1a1a1a]">
            Ready to Elevate<br />the Clinic Experience?
          </h2>
          <p className="lg:col-span-5 text-[#4a4a4a] leading-relaxed">
            Let&apos;s build exceptional experiences that drive growth and loyalty.
          </p>
          <div className="lg:col-span-3 flex lg:justify-end">
            <button
              type="button"
              onClick={() => setOpen(true)}
              className="btn-outline-gold group inline-flex items-center gap-6 px-8 py-4 text-[10px] tracking-[0.3em] uppercase cursor-pointer"
            >
              Book a Consultation
              <ArrowRight size={14} className="hover-arrow" />
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-page py-20 border-t border-[#eee]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-12">
          {/* Brand */}
          <div className="lg:col-span-6">
            <div className="flex flex-col items-start leading-none mb-8">
              <span className="font-serif text-2xl tracking-[0.35em] text-[#1a1a1a]">TINDE</span>
              <span className="text-[9px] tracking-[0.3em] text-[#7a7a7a] mt-1">PATIENT EXPERIENCE CONSULTING</span>
            </div>
            <div className="flex items-center gap-5">
              <a href="#" aria-label="Instagram" className="social-icon"><Instagram size={18} strokeWidth={1.4} /></a>
              <a href="https://www.linkedin.com/company/tindeconsulting/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="social-icon"><Linkedin size={18} strokeWidth={1.4} /></a>
              <a href="#" aria-label="WhatsApp" className="social-icon"><MessageCircle size={18} strokeWidth={1.4} /></a>
            </div>
          </div>

          {/* Contact */}
          <div className="lg:col-span-6 lg:text-right">
            <h5 className="text-[11px] tracking-[0.3em] uppercase text-[#1a1a1a] mb-6">Contact</h5>
            <ul className="space-y-3 text-sm text-[#4a4a4a]">
              <li><a href="mailto:contact@tindeconsulting.com" className="footer-link">contact@tindeconsulting.com</a></li>
              <li><a href="tel:+966506493440" className="footer-link">+966 50 649 3440</a></li>
              <li>Riyadh, Saudi Arabia</li>
            </ul>
          </div>
        </div>

        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 mt-16 pt-8 border-t border-[#eaeaea]">
          <p className="text-center text-[11px] tracking-[0.25em] uppercase text-[#7a7a7a]">
            &copy; 2025 Tinde Patient Experience Consulting. All Rights Reserved.
          </p>
        </div>
      </footer>

      <ConsultationDialog open={open} onClose={() => setOpen(false)} />
    </>
  );
}
